const postFilterOptions = [
  {
    value: 'latest',
    text: 'Latest',
  },
  {
    value: 'unanswered',
    text: 'Unanswered',
  },
  {
    value: 'popular',
    text: 'Popular',
  },
  {
    value: 'pinned',
    text: 'Pinned',
  },
  {
    value: 'active',
    text: 'Recently active',
  },
  {
    value: 'polls',
    text: 'Polls',
  },
];

export default postFilterOptions;
